// getters.js

export default {
    getNotificationList(state){
        return state.notificationList
    },
};
